import { Autocomplete, TextField } from "@mui/material";

const PercentageSelect = ({
  value,
  onChange,
  title = "Select Percentage",
  placeholder,
  size = "sm", // sm | md
  fullWidth = true,
  className,
  style = {},
  excluded = [], // 🚫 array of numbers to exclude
  symbol,
}) => {
  // Filter 1-100 and exclude values in the 'excluded' list
  const options = Array.from({ length: 100 }, (_, i) => i + 1).filter(
    (num) => !excluded.includes(num)
  );  

  const handleChange = (newValue) => {
    if (!onChange) return;

    if (
      typeof newValue === "number" &&
      newValue >= 1 &&
      newValue <= 100 &&
      !excluded.includes(newValue)
    ) {
      onChange(newValue);
    } else {
      onChange(null); // or leave undefined if you want to reset
    }
  };

  const sizeMap = {
    sm: "small",
    md: "medium",
  };

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => `${option}${symbol || ""}`}
      value={options.includes(value) ? value : null}
      onChange={(_, newValue) => handleChange(newValue)}
      isOptionEqualToValue={(option, val) => option === val}
      fullWidth={fullWidth}
      clearOnEscape
      renderInput={(params) => (
        <TextField
          {...params}
          label={title}
          placeholder={placeholder || title}
          size={sizeMap[size]}
          variant="outlined"
        />
      )}
      className={className}
      style={style}
    />
  );
};

export default PercentageSelect;
